import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from "@react-oauth/google";

import { GOOGLE_ID } from './constants/index.js';
import App from './App.jsx'

import './assets/css/main.css';
// import './assets/js/main.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={GOOGLE_ID}>
    <App />
  </GoogleOAuthProvider>
);

reportWebVitals();
